import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top left
  }, [pathname]); // Runs on pathname change

  return null; // This component does not render anything
};

export default ScrollToTop;